export default __webpack_public_path__ + "static/media/img17.ccc9536f.jpg";